import { useEffect, useState } from 'react';

const resolveCSSVariable = (query: string): string => {
    if (!query.includes('var(')) return query;
    return query.replace(/var\((--[^)]+)\)/g, (_, cssVar) => {
        const value = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
        return value || '0px';
    });
};

export const useMediaQuery = (query: string, defaultValue: boolean): boolean => {
    const [matches, setMatches] = useState<boolean>(defaultValue || false);

    useEffect(() => {
        const resolvedQuery = resolveCSSVariable(query);
        const mediaQueryList = window.matchMedia(resolvedQuery);
        const documentChangeHandler = () => setMatches(mediaQueryList.matches);
        setMatches(mediaQueryList.matches);

        mediaQueryList.addEventListener('change', documentChangeHandler);

        return () => {
            mediaQueryList.removeEventListener('change', documentChangeHandler);
        };
    }, [query]);

    return matches;
};
